import { connect } from 'react-redux';
import AssetMapping from "./assetMapping";
import { bindActionCreators } from 'redux';
import {
  getParentMaterials,
  getAssetsAndMakeData,
  saveSitesAssetsGateWise
} from 'services/redux/installation/siteListing/action';
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    parentMaterials: state.siteListingReducer.parentMaterials
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getParentMaterials,
      getAssetsAndMakeData,
      documentUploadUrl,
      documentUploadUrlPublic,
      saveSitesAssetsGateWise
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AssetMapping);
